"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var ReactSafeHtml = require('react-safe-html');

var components = ReactSafeHtml.components.makeElements({});
components.p = ReactSafeHtml.components.createSimpleElement('p', {});
components.ul = ReactSafeHtml.components.createSimpleElement('ul', {});
components.ol = ReactSafeHtml.components.createSimpleElement('ol', {});
components.li = ReactSafeHtml.components.createSimpleElement('li', {});
components.th = ReactSafeHtml.components.createSimpleElement('th', {});
components.blockquote = ReactSafeHtml.components.createSimpleElement('blockquote', {});
components.figure = ReactSafeHtml.components.createSimpleElement('figure', {});
components.figcaption = ReactSafeHtml.components.createSimpleElement('figcaption', {});

var WysiwygSafeHtml = function WysiwygSafeHtml(props) {
  var html = props.html,
      other = (0, _objectWithoutPropertiesLoose2.default)(props, ["html"]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: "WysiwygSafeHtml"
  }, other), /*#__PURE__*/_react.default.createElement(ReactSafeHtml, {
    html: html,
    components: components
  }));
};

WysiwygSafeHtml.propTypes = {
  html: _propTypes.default.string
};
WysiwygSafeHtml.defaultProps = {};
WysiwygSafeHtml.displayName = 'WysiwygSafeHtml';
var _default = WysiwygSafeHtml;
exports.default = _default;